<template>
    <div class="actions-items">
        <!-- {{actionsItems}} -->
        <div class="action-item" v-for="item in actionsItems" :class="{animate : actionCardAnimate}">
            <div class="column-container">
                <div class="col-left">
                    <div class="action-img">
                        <img :src="item.action_img" alt="">
                    </div>
                </div>
                <div class="col-right">
                    <div class="action-title">
                        <h3>{{item.action_title}}</h3>
                    </div>
                    <div class="action-desc">
                        <p>{{item.action_desc_mini}}</p>
                    </div>
                    <div class="btn-more">
                        <router-link :to="{ name : 'action-card' , params:{id : item.action_key_word, title :  item.action_title}}" v-if="item.action_key_word != ''">Подробнее</router-link>
                        <router-link :to="{ name : 'action-card', params:{id : cytTolat(item.action_title), title :  item.action_title}}" v-else>Подробнее</router-link>
                        <!-- cyrillicToTranslit().transform('привет мир!', "_") -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    export default {
        name: 'action-item',
        components: {
        },
        data () {
            return {
            }
        },
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            }
        },
        computed: mapGetters({
            actionsItems: 'loadActionsItems',
            actionCardAnimate: 'loadActionCardAnimateStatus',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/actions/action-item.scss';
    @import '@/styles/respond/actions/respond-action-item.scss';
</style>